import styled from 'styled-components';
import { colors, MediaQuery } from '../../../theme/style-helpers';

export const FileUploadContainer = styled.div`
    padding: 27px 8px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    border-bottom: 1px solid ${colors.COOL_GREY};
    justify-content: space-between;

    &.inline {
        padding-top: 10px;
        padding-bottom: 10px;
        border: none;
    }

    p.label {
        ${MediaQuery.large`
            max-width: 55%;
            margin-bottom: 0;
        `}

        margin-bottom: 10px;
    }
`;

export const FileUpload = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: flex-end;
    gap: 6px;

    label {
        font-size: 16px;
        display: flex;
        align-items: center;
        gap: 6px;
        margin: 0;

        span {
            padding-bottom: 2px;
        }

        img {
            height: 16px;
            width: 16px;
            max-width: unset;
        }

        &:hover {
            cursor: pointer;
        }
    }
`;

export const UploadedFile = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    font-weight: 600;
    width: 100%;

    ${MediaQuery.medium`
        width: unset;
    `}

    span {
        img {
            height: 14px;
            width: 14px;
        }
    }
`;
